import React, { FunctionComponent } from 'react';
import { isArray } from '@/utils/isArray';
import { Col, Container, Row } from '@visalex/core';

import { VisaPageProcessStep } from '../../VisaPage';
import ListItem from '../ListItem/ListItem';

import styles from './ProcessStepsSection.module.scss';

type ProcessStepsSectionProps = {
  title: string;
  subtitle: string;
  steps: VisaPageProcessStep[];
};

const ProcessStepsSection: FunctionComponent<ProcessStepsSectionProps> = ({ title, subtitle, steps }) => {
  return (
    <section className={styles['visa-page__process-step-section']}>
      <Container>
        <Row>
          <Col md={12} lg={8} className="text-align-left">
            <h2 className={styles['visa-page__title']}>{title}</h2>
            <p className={styles['visa-page__subtitle']}>{subtitle}</p>
          </Col>
        </Row>
        <Row className={styles['visa-page__process-steps-list']}>
          {isArray(steps) &&
            steps.map((step, key) => (
              <Col xs={12} md={6} lg={4} key={key} className={styles['visa-page__process-step']}>
                <ListItem step={step} positionNumber={key} isLast={key === steps.length - 1} />
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  );
};

export default ProcessStepsSection;
